import {createSelector} from "@reduxjs/toolkit";

export const selectSessionPermissions = createSelector(
  s => s.accessControlSession?.user?.roles,
  roles => (roles || []).map(r => r.permissions).flat()
);
